import { memo, useContext } from "react";
import { skipToken } from "@reduxjs/toolkit/query";
import { useTranslation } from "react-i18next";
import { ScreenReaderText, StatisticCard, ThemeWrapper } from "@verity/components";
import { PortalControllerContext } from "../../context";
import { useGetRosterStatisticsQuery } from "./store/roster-api";
import AdminsIcon from "./icons/admins.svg?react";
import InstructorsIcon from "./icons/instructors.svg?react";
import StudentsIcon from "./icons/students.svg?react";
import UsersIcon from "./icons/users.svg?react";
import { MemoizedRosterTable } from "./roster-table";
import VisualizerBanner from "../visualizer-banner";
import styles from "./roster-page.module.css";

const RosterPage = () => {
	const { portalContext } = useContext(PortalControllerContext);
	const { lms, instituteUuid } = portalContext;
	const { data: statistics, isLoading } = useGetRosterStatisticsQuery(instituteUuid ?? skipToken);

	const { t } = useTranslation();

	return (
		<ThemeWrapper scopedCssBaselineProps={{ className: styles.wrapper }}>
			<div className={styles.containerBackground}>
				<ScreenReaderText component="h1">{t("portal.components.roster.title")}</ScreenReaderText>
				<div className={styles.container}>
					<VisualizerBanner />
					<div className={styles.headerContainer}>
						<StatisticCard
							header={t("portal.components.roster.statistics.totalUsers")}
							icon={<UsersIcon />}
							value={(statistics?.admin ?? 0) + (statistics?.instructor ?? 0) + (statistics?.student ?? 0)}
							dataLoading={isLoading || !statistics}
						/>
						<StatisticCard
							header={t("portal.components.roster.statistics.totalAdmins")}
							icon={<AdminsIcon />}
							value={statistics?.admin}
							dataLoading={isLoading || !statistics}
						/>
						<StatisticCard
							header={t("portal.components.roster.statistics.totalInstructors")}
							icon={<InstructorsIcon />}
							value={statistics?.instructor}
							dataLoading={isLoading || !statistics}
						/>
						{(lms || (statistics?.student != null && statistics.student > 0)) && (
							<StatisticCard
								header={t("portal.components.roster.statistics.totalStudents")}
								icon={<StudentsIcon />}
								value={statistics?.student}
								dataLoading={isLoading || !statistics}
							/>
						)}
					</div>
					<MemoizedRosterTable />
				</div>
			</div>
		</ThemeWrapper>
	);
};

export const MemoizedRosterPage = memo(RosterPage);
